<template>
  <div class="article-frame page-article-frame">
    <iframe
      :src="iframeSrc"
      class="article-frame__iframe"
      frameborder="0"
      title="图文内容"
    />
  </div>
</template>

<script>
import { env } from '@zyf2e/adapt';
import { encyclopediaEntryVisitTimes } from '@/services';

export default {
  data() {
    return {
      iframeSrc: ''
    };
  },
  mounted() {
    const { url, accessibilityType, title, imgUrl, id } = this.$route.query || {};

    this.iframeSrc = decodeURIComponent(url);

    if (env.inWechatMiniProgram) {
      let isShowShareMenu = 1;
      if (parseInt(accessibilityType) === 2) {
        isShowShareMenu = 0;
      }

      window.wx.miniProgram.postMessage({
        data: {
          title: title,
          imageUrl: imgUrl,
          pageUrl: window.location.href,
          isShowShareMenu
        }
      });
    }

    this.recordVisitor(id).then(() => {});

    this.telescope.trackEvent({
      trackId: 'zyxcx-click-secondhealthcategory',
      custom: { url, accessibilityType, title, imgUrl, id }
    });
  },
  methods: {
    async recordVisitor(id) {
      return encyclopediaEntryVisitTimes({ id: ~~id });
    }
  }
};
</script>

<style lang="less" scoped>
.page-article-frame {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #fff;
}

.article-frame__iframe {
  flex: 1;
  width: 100%;
  border: 0;
  min-height: 100vh;
}

@media (min-width: 768px) {
  .page-article-frame {
    margin: 16px 24px 24px;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.08);
    min-height: calc(100vh - 40px);
  }

  .article-frame__iframe {
    min-height: calc(100vh - 40px);
  }
}
</style>
